import { lazyLoad } from '@utils/router'
const routes = [
  {
    path: '/home/KnowledgeLib',
    component: lazyLoad(() => import('@views/KnowledgeLib/pages/HomeMain')),
  },
  {
    path: '/home/myFiles/:type',
    component: lazyLoad(() => import('@views/KnowledgeLib/pages/MyFiles')),
  },
  {
    path: '/home/allKnowledgeLib/:id?',
    component: lazyLoad(() =>
      import('@views/KnowledgeLib/pages/AllKnowledgeLib')
    ),
  },
  {
    path: '/home/knowledgeLibDetail/:id/:indexId?',
    component: lazyLoad(() =>
      import('@views/KnowledgeLib/pages/AllKnowledgeLib/Detail')
    ),
  },
]

export default routes
